export const phoneValidator = (telefono: string) => {
	// Eliminar los espacios del telefono
	telefono = telefono.replace(/\s/g, '');
	// Verificar que empieza con 9 y tiene exactamente 9 dígitos
	const isValidFormat = /^9\d{8}$/.test(telefono);
	return isValidFormat;
}

export const formatTelefono = (telefono: string) => {
	const cleaned = telefono.replace(/\D/g, '');
	let formatted = cleaned;
	// Agregar espacio después del primer dígito
	if (cleaned.length > 1) {
		formatted = `${cleaned[0]} ${cleaned.slice(1, 5)}`;
	}
	// Agregar espacio después del quinto dígito
	if (cleaned.length > 5) {
		formatted += ` ${cleaned.slice(5, 9)}`;
	}
	return formatted;
};